/**
 * Formats a date to dd-mm-yy format
 * @param {Date|string|number} date - Date object, ISO string, or timestamp
 * @returns {string} Formatted date in dd-mm-yy format
 */
export const formatDateDDMMYY = (date) => {
  if (!date) return '';
  
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Check if date is valid
  if (isNaN(dateObj.getTime())) return '';
  
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = String(dateObj.getFullYear()).slice(-2); // Get last 2 digits of year
  
  return `${day}-${month}-${year}`;
};

/**
 * Formats a date to dd-mm-yy format for CSV filenames
 * @param {Date|string|number} date - Date object, ISO string, or timestamp
 * @returns {string} Formatted date in dd-mm-yy format
 */
export const formatDateForFilename = (date = new Date()) => {
  return formatDateDDMMYY(date);
};

/**
 * Formats a date string (from backend) to dd-mm-yy format
 * Handles various date formats like YYYY-MM-DD, DD-MM-YYYY, etc.
 * @param {string} dateString - Date string from backend
 * @returns {string} Formatted date in dd-mm-yy format
 */
export const formatDateString = (dateString) => {
  if (!dateString) return '';
  
  // If it's already in a format we can parse, use it
  const dateObj = new Date(dateString);
  if (!isNaN(dateObj.getTime())) {
    return formatDateDDMMYY(dateObj);
  }
  
  // Try to parse common formats
  // If format is YYYY-MM-DD, convert to dd-mm-yy
  const yyyyMMdd = /^(\d{4})-(\d{2})-(\d{2})/;
  const match = dateString.match(yyyyMMdd);
  if (match) {
    const [, year, month, day] = match;
    const yy = year.slice(-2);
    return `${day}-${month}-${yy}`;
  }
  
  return dateString; // Return as-is if we can't parse it
};


